import React from "react";
import { DialogContent, DialogActions, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "./Modal.slice";
import {
  ModalRoot,
  ModalTitleRoot,
  ModalCloseButton,
  ModalContentWrapper,
} from "./Modal.styles";
// Importar el componente AcquirerShower
import { AcquirerShower } from "../lists/Acquierer/Acquirer.show";

const Modal = ({ children, actions, disableBackdropClick = false }) => {
  const dispatch = useDispatch();
  const { 
    isOpen, 
    title, 
    maxWidth, 
    fullWidth, 
    fullScreen,
    children: storeChildren,
    actions: storeActions,
    contentType,
    contentProps
  } = useSelector((state) => state.modal);

  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === "backdropClick") {
      return;
    }
    dispatch(closeModal());
  };

  // Función para renderizar contenido dinámico
  const renderDynamicContent = () => {
    switch (contentType) {
      case 'acquirer-show':
        return <AcquirerShower {...contentProps} />;
      default:
        return storeChildren || children;
    }
  };

  // Priorizar children y actions pasados como props, sino usar los de la store
  const modalChildren = renderDynamicContent();
  const modalActions = storeActions || actions;

  return (
    <ModalRoot
      open={isOpen}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      {title && (
        <ModalTitleRoot id="modal-title">
          <Typography variant="h6" component="div">
            {title}
          </Typography>
          <ModalCloseButton
            aria-label="close"
            onClick={() => dispatch(closeModal())}
          >
            <CloseIcon />
          </ModalCloseButton>
        </ModalTitleRoot>
      )}

      <DialogContent dividers>
        <ModalContentWrapper hasTitle={!!title}>
          {modalChildren}
        </ModalContentWrapper>
      </DialogContent>

      {modalActions && <DialogActions>{modalActions}</DialogActions>}
    </ModalRoot>
  );
};

export default Modal;
